import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Phone, Mail, FileText } from 'lucide-react';

const QuickActionsCard = ({ language, lead, setActiveTab }) => {
  return (
    <Card className="bg-gray-50">
      <CardContent className="py-4">
        <div className="flex flex-wrap gap-2">
          {lead.client_phone && (
            <a href={`tel:${lead.client_phone}`}>
              <Button variant="outline" size="sm" className="border-green-500 text-green-600 hover:bg-green-50">
                <Phone className="mr-2 h-4 w-4" />
                {language === 'es' ? 'Llamar' : 'Call'}
              </Button>
            </a>
          )}
          {lead.client_email && (
            <a href={`mailto:${lead.client_email}?subject=Proposal ${lead.proposal_id || lead.estimate_number}`}>
              <Button variant="outline" size="sm" className="border-blue-500 text-blue-600 hover:bg-blue-50">
                <Mail className="mr-2 h-4 w-4" />
                {language === 'es' ? 'Email' : 'Email'}
              </Button>
            </a>
          )}
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => setActiveTab('proposal')}
            className="border-amber-500 text-amber-600 hover:bg-amber-50"
          >
            <FileText className="mr-2 h-4 w-4" />
            {language === 'es' ? 'Ver Propuesta' : 'View Proposal'}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default QuickActionsCard;
